import createMetaMixin from 'quasar/src/utils/create-meta-mixin/create-meta-mixin.js';
export default {
  name: 'App',
  mixins: [createMetaMixin({
    title: 'Home',
    titleTemplate: title => `${title} | Nave Vendas`
  })]
};